export const ENTRY_POINT = "https://decocakes-981ca-default-rtdb.firebaseio.com";
export const SALSIFY_END_POINT = "https://app.salsify.com/api/v1/orgs/s-c599e44b-be31-4ef9-8b23-123cf4a38542/products";
// export const SALSIFY_PROXY_END_POINT = "http://localhost:82/api/v1";
export const SALSIFY_PROXY_END_POINT = "https://bakerytechs.net/api/v1";
export const SALSIFY_IMAGE_URI = "https://images.salsify.com/image/upload/s--tgPXviy8--/c_pad,cs_srgb,q_80,h_1000,w_1000/";
